import { Component, OnInit, Input, ChangeDetectionStrategy, Inject } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-stats',
    templateUrl: './stats.shared.component.html',
    styleUrls: ['./stats.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatsComponent implements OnInit {
    @Input() public stats: OLO.Components.IStatsComponentInput = {};
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void { }

    public get energy(): string {
        return this.stats?.kilojoules ?
            this.config.energyUnits === 1 ? this.stats.kilojoules + 'kJ' : this.stats.cals + 'cals'
            : null;
    }
}
